import BooksSlider from "./components/BooksSlider"
import SeeMoreLink from "../../components/common/SeeMoreLink"
import LatestBooksTitle from "./components/LatestBooksTitle"
import { useTranslation } from 'react-i18next';

export default function LatestBooks() {
    const { t } = useTranslation();

    return (
        <div className="col-12 py-4 pe-5 mt-4">
            <div className="d-flex justify-content-between align-items-start">
                <LatestBooksTitle />
                <SeeMoreLink linkTo="/masarLibrary" linkValue={t("More")} />
            </div>
            <BooksSlider />
        </div>
    )
}
